export function isPresent(...itemsToCheck) {
  return itemsToCheck.findIndex(element => element) >= 0;
}
